// extracted by mini-css-extract-plugin
export var addToCartButton = "_nl-b";
export var arrowButtonContainer = "_nl-9";
export var arrowButtonIcon = "_nl-a";
export var carouselArrowButton = "_nl-6";
export var carouselElementContainer = "_nl-1";
export var left = "_nl-7";
export var productDisplayCarouselContainer = "_nl-0";
export var productTileContainer = "_nl-2";
export var productTileImage = "_nl-4";
export var productTileImageContainer = "_nl-3";
export var productTileTitle = "_nl-5";
export var right = "_nl-8";
export var sliderOverflow = "_nl-c";